<template>
  <div class="projection--container">
    <div v-for="(field, index) in fieldsForm" :key="index">
      <form-render :form.sync="form" :fields="field" :key="keyFormRender" formClass="form--list-tickets">
        <template slot="buttonAdd">
          <b-button variant="outline-primary" v-b-tooltip.hover title="Añadir proyección de otro courier/bodega" @click="addValueForm"><feather-icon icon="PlusIcon" /></b-button>
        </template>
        <template #buttonRemove="scope">
          <b-button variant="outline-danger" v-b-tooltip.hover title="Eliminar proyección de otro courier/bodega" @click="removeField(scope.field.id)"><feather-icon icon="Trash2Icon" /></b-button>
        </template>
      </form-render>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    arrayData: {
      type: Object,
      default: () => {
        return {
          warehouses: [],
          carriers: []
        }
      }
    },
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    sizeWeek: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      iterationCounter: 0,
      fieldsForm: [],
      keyFormRender: 0,
      debounceTimeout: null
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.checkForm()
        this.$emit('update:form', newVal)
      },
      immediate: true,
      deep: true
    },
    sizeWeek: {
      handler(newVal) {
        for (let index = 1; index < newVal; index++) {
          this.addValueForm()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.addValueForm() 
  },
  methods: {
    checkForm() {
      let hasError = false
      for (const key in this.fieldsForm) {
        const fieldGroup = this.fieldsForm[key]
        for (const field of fieldGroup) {
          const isButton = field.name === 'buttonAdd' || field.name === 'buttonRemove'
          const hasValidation = !!field.validation
          const formValue = !this.form[field.name]
          field.msgError = formValue && !isButton && hasValidation ? 'Este campo es requerido' : null
          if (field.msgError) {
            hasError = true
          }
        }
      }
      this.$emit('disableSend', hasError)
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.keyFormRender++
      }, 2000)
    },
    generateFieldsFormGroup() {
      return [
        {
          fieldType: 'FieldInput',
          name: `projection_${this.iterationCounter}`,
          type: 'number',
          validation: 'required',
          label: 'Proyección total de unidades a despachar Cyber Junio 2025',
          containerClass: 'col-5',
          debounce: 500
        }, 
        { 
          fieldType: 'FieldSelect',
          name: `courier_${this.iterationCounter}`,
          label: 'Courier',
          containerClass: 'col-3',
          options: this.arrayData.carriers,
          searchOnType: { nChars: 999},
          validation: 'required'
        },
        { 
          fieldType: 'FieldSelect',
          name: `warehouse_${this.iterationCounter}`,
          label: 'Bodega',
          containerClass: 'col-3',
          options: this.arrayData.warehouses,
          searchOnType: { nChars: 999},
          validation: 'required'
        }
      ]
    },
    addValueForm() {
      const fieldCount = Object.keys(this.fieldsForm).length
      const newFields = [
        ...this.generateFieldsFormGroup(),
        fieldCount === 0 ? { name: 'buttonAdd', useSlot: true, id: this.iterationCounter, containerClass: 'mt-2 col-1 d-flex justify-content-center'} : null,
        fieldCount > 0 ? { name: 'buttonRemove', useSlot: true, id: this.iterationCounter,  containerClass: 'mt-2 col-1 d-flex justify-content-center' } : null
      ].filter(Boolean)
      this.fieldsForm = { ...this.fieldsForm, [this.iterationCounter]: newFields }
      this.iterationCounter++
      this.keyFormRender++
      this.checkForm()
    },
    removeField(id) {
      delete this.fieldsForm[id]
      for (const key in this.form) {
        if (key.endsWith(`_${id}`)) {
          delete this.form[key]
        }
      }
      this.keyFormRender++
      this.checkForm()
    }
  }
}
</script>
<style lang="scss">
  .projection--container {
    margin-bottom: 15px
  }
</style>